import { SDKStatusCode } from "@nebula-sdk/core";
import { defineComponent, onMounted, ref, onUnmounted } from "vue";
import Popup from "../../share/popup";
import type { NebulaWEBGameSDKPayment } from "@nebula-sdk/compose";
import type { SDKResult } from "@nebula-sdk/core";
import type { PropType } from "vue";

import "./index.less";

export default defineComponent({
  props: {
    service: { type: Object as PropType<NebulaWEBGameSDKPayment>, required: true },
    data: { type: Object as PropType<Record<string, string>>, required: true },
    success: { type: Function as PropType<(result: SDKResult<null>) => void>, required: true },
    error: { type: Function as PropType<(result: SDKResult<null>) => void>, required: true },
  },
  setup(props) {
    const visible = ref(false);

    const onConfirmClick = () => {
      visible.value = false;
      props.success({
        status: "success",
        code: SDKStatusCode.Success,
        msg: "回调成功",
        data: null,
      });
    };

    onMounted(async () => {
      const result = await props.service.requestOrderQuery({
        orderNo: props.data.orderNo,
        orderToken: props.data.orderToken,
      });
      visible.value = result.status === "success";
    });

    onUnmounted(() => {
      visible.value = false;
    });

    return () => (
      <Popup closeOnOverlayClick={false} position="center" visible={visible.value} width={320}>
        <div class="feiyu-web-service-callback-success">
          <div class="feiyu-web-service-callback-success--title">{"支付成功"}</div>
          <div class="feiyu-web-service-callback-success--content">{"请前往游戏内查收商品"}</div>
          <div class="feiyu-web-service-callback-success--button" onClick={onConfirmClick}>
            {"确定"}
          </div>
        </div>
      </Popup>
    );
  },
});
